import React from 'react';
import Step from './Step';
import './HowItWorks.css';

// Import all images
import step1Image from '../../assets/LeasEiZi_Step-1.png';
import step2Image from '../../assets/LeasEiZi_Step-2.png';
import step3Image from '../../assets/LeasEiZi_Step-3.png';
import step4Image from '../../assets/LeasEiZi_Step-4.png';
import avatar1 from '../../assets/avatar1.png';
import avatar2 from '../../assets/avatar2.png';
import avatar3 from '../../assets/avatar3.png';
import avatar4 from '../../assets/avatar4.png';

function HowItWorks() {
  const steps = [
    {
      stepNumber: 1,
      title: "Enter Apartment URL",
      description: "Copy the URL to the apartment unit you'd like to track. Paste the URL in our form below.",
      image: step1Image,
      chatBubbles: [
        {
          type: "user-bubble",
          avatar: avatar3,
          text: "Did you know apartment prices change daily!"
        },
        {
          type: "response-bubble",
          text: "😡 🤯 🤔 😤 🤬"
        }
      ]
    },
    {
      stepNumber: 2,
      title: "Enter the Apartment Info",
      description: "Tell us the Apartment Name, Apartment Floor Plan, Lease Start Date and the Unit Number of the apartment you'd like to track.",
      image: step2Image,
      chatBubbles: [
        {
          type: "user-bubble",
          avatar: avatar2,
          text: "Keep track of multiple apartment rates with LeasEiZi!"
        },
        {
          type: "response-bubble",
          text: "No Way! 🤯"
        }
      ]
    },
    {
      stepNumber: 3,
      title: "Enter Your Ideal Price",
      description: "Let us know ideally at what price would you lease the apartment so we can send you an alert.",
      image: step3Image,
      chatBubbles: [
        {
          type: "user-bubble",
          avatar: avatar1,
          text: "Obtain the Best Price!"
        },
        {
          type: "response-bubble",
          text: "I need this! 😊"
        }
      ]
    },
    {
      stepNumber: 4,
      title: "Enter your email address",
      description: "Input your email address so we can save your tracked apartments and send you price alerts!",
      image: step4Image,
      chatBubbles: [
        {
          type: "user-bubble",
          avatar: avatar4,
          text: "Your apartment price target is reached! Lease Now!"
        }
      ]
    }
  ];

  return (
    <section id="howitworks" className="how-it-works">
      <h2>LeasEiZi makes Apartment Lease Saving Easy</h2>
      <p className="how-it-works-p">Apartment Price Tracking in 4 easy steps.</p>
      <div className="steps">
        {steps.map((step) => (
          <Step 
            key={step.stepNumber}
            stepNumber={step.stepNumber}
            title={step.title}
            description={step.description}
            image={step.image}
            chatBubbles={step.chatBubbles}
          />
        ))}
      </div>
    </section>
  );
}

export default HowItWorks;
